import React from "react";
import SecondaryHeading from "../../components/common/Typography/SecondaryHeading";
import AuxiliaryText from "../../components/common/Typography/AuxiliaryText";

const Keywords = ({ userData, className = "", onViewAllClick }) => {
  // Fallback data when userData is not available or keywords is empty
  const fallbackKeywords = [
    "Air con & Heating", "Architects & Design", "Block & Awning", 
    "Carpet & Flooring", "Bricklaying", "Construction", 
    "Renovation", "Design"
  ];

  // Get keywords from userData or use fallback
  const keywords = userData?.keywords && userData.keywords.length > 0 
    ? userData.keywords 
    : fallbackKeywords;

  return (
    <div className={`mb-8 ${className}`}>
      <SecondaryHeading variant={"MainParagraphHeading"} className={"text-offblack mb-4"}>
        Keywords
      </SecondaryHeading>
      <div className="flex flex-wrap gap-3">
        {keywords.map((keyword, index) => (
          <AuxiliaryText
            key={index}
            variant={"CtaChip"}
            className="bg-white text-offblack"
          >
            {keyword}
          </AuxiliaryText>
        ))}
      </div>
      {onViewAllClick && (
        <button
          type="button"
          onClick={onViewAllClick}
          className="w-full mt-4 link-cta font-inter normal-case text-center hover:text-primaryblue cursor-pointer"
        >
          View all keywords
        </button>
      )}
    </div>
  );
};

export default Keywords;
